module.exports = __webpack_public_path__ + "static/Front_exterior_of_Freemasons_Hall_London-32e6fb36cce717bcd664eb748fdf32cb.jpg";